
export default {
  confirmSpend: {
    your_balance: 'Su saldo:',
    token_unit: 'OCC Tokens',
    non_active_employees: 'Debe tener al menos un colaborador activo para esta encuesta.',
    acquire_tokens: 'Adquirir más OCC Tokens',
    input_cancel: 'Cancelar',
    operation_failed: 'Operación no exitosa, se recomienda:',
    no_balance: 'Sin balance suficiente',
    balance_after: 'Saldo luego de crear la valoración:',
    no_balance_msg: 'Empresa sin saldo suficiente, si continua el proceso, el sistema intentará consumir saldos autorizados.',
    input_confirm_save: 'Confirmar',
    input_update: 'Actualizar'
  }
}
